
export const sidebarUser = {
  'backoffice.sidebarUser.sections.dashboard.title': 'Dashboard',
  'backoffice.sidebarUser.sections.dashboard.items.summary': 'Zusammenfassung',
  'backoffice.sidebarUser.sections.myCommunity.title': 'Meine Gemeinschaft',
  'backoffice.sidebarUser.sections.myCommunity.items.genealogyTree': 'Stammbaum',
  'backoffice.sidebarUser.sections.myCommunity.items.communityMembers': 'Gemeinschaftsmitglieder',
  'backoffice.sidebarUser.sections.investmentAccounts.title': 'Investment-Konten',
  'backoffice.sidebarUser.sections.investmentAccounts.items.myAccounts': 'Meine Konten',
  'backoffice.sidebarUser.sections.investmentAccounts.items.addAccount': 'Konto hinzufügen',
  'backoffice.sidebarUser.sections.myProfits.title': 'Meine Gewinne',
  'backoffice.sidebarUser.sections.myProfits.items.accountsProfitSummary': 'Kontoprofit-Zusammenfassung',
  'backoffice.sidebarUser.sections.myProfits.items.accountsProfitHistory': 'Kontoprofit-Verlauf',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsSummary': 'Provisionen-Zusammenfassung',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsHistory': 'Provisionen-Verlauf',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsPaymentHistory': 'Provisionen-Zahlungsverlauf',
  'backoffice.sidebarUser.sections.myProfits.items.myPaymentMethods': 'Meine Zahlungsmethoden',
  'backoffice.sidebarUser.sections.startInvesting.title': 'Investieren beginnen',
  'backoffice.sidebarUser.sections.startInvesting.items.createRadexAccount': 'Radex Markets Konto erstellen',
  'backoffice.sidebarUser.sections.startInvesting.items.joinPammInstitutional': 'PAMM Institutional Trading beitreten',
  'backoffice.sidebarUser.sections.startInvesting.items.joinPammSpartanAi': 'PAMM Spartan AI beitreten',
  'backoffice.sidebarUser.sections.startInvesting.items.accessPammAccount': 'Auf Ihr PAMM-Konto zugreifen',
  'backoffice.sidebarUser.sections.tutorials.title': 'Tutorials',
  'backoffice.sidebarUser.sections.myProfile.title': 'Mein Profil',
  'backoffice.sidebarUser.sections.myProfile.items.theClubUserProfile': 'The Club Benutzerprofil',
  'backoffice.sidebarUser.sections.myProfile.items.personalInformation': 'Meine persönlichen Informationen',
  'backoffice.sidebarUser.sections.myProfile.items.paymentMethods': 'Meine Zahlungsmethoden',
  'backoffice.sidebarUser.sections.myProfile.items.referralLink': 'Mein Empfehlungslink',
  'backoffice.sidebarUser.sections.support.title': 'Support',
  'backoffice.sidebarUser.sections.support.items.helpCenter': 'Hilfezentrum',
  'backoffice.sidebarUser.signOut': 'Abmelden'
};
